import { all, takeLatest, put } from 'redux-saga/effects';
import { GET_ROUNDS, ADD_ROUND, UPDATE_ROUND, DELETE_ROUND } from './constants';
import { requestRounds, requestAddRound, requestUpdateRound, requestDeleteRound } from './api';
import { getRoundsSuccess, addRoundSuccess, updateRoundSuccess, deleteRoundSuccess } from './actions';

/**
 *
 * @returns {IterableIterator<PutEffect<{rounds: *, type: string}>>}
 */
function* getRounds(obj) {
    const rounds = yield requestRounds(obj.id);
    if (rounds) {
        yield put(getRoundsSuccess(rounds));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{rounds, type}>>}
 */
function* addRound(actionObj) {
    const rounds = yield requestAddRound(actionObj.formData);
    if (rounds) {
        yield put(addRoundSuccess(rounds));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{rounds, type}>>}
 */
function* updateRound(actionObj) {
    const rounds = yield requestUpdateRound(actionObj.formData);
    if (rounds) {
        yield put(updateRoundSuccess(rounds));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{rounds, type}>>}
 */
function* deleteRound(actionObj) {
    const rounds = yield requestDeleteRound(actionObj.id);
    if (rounds) {
        yield put(deleteRoundSuccess(rounds));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchRounds() {
    yield takeLatest(GET_ROUNDS, getRounds);
    yield takeLatest(ADD_ROUND, addRound);
    yield takeLatest(UPDATE_ROUND, updateRound);
    yield takeLatest(DELETE_ROUND, deleteRound);
}

function* roundsSaga() {
    yield all([
        watchRounds()
    ]);
}

export default roundsSaga;